import styles from "./AssessmentFooter.module.scss";

interface Props {
  children: React.ReactNode;
}

export const AssessmentFooter: React.FC<Props> = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};
